/**
 * An IIFE service which provides a methods for interacting with native application (when in a webview)
 * Provides pub/sub methods based on https://davidwalsh.name/pubsub-javascript
 *
 * @function NativeService
 * @returns {object} Various public interface methods
 */
const NativeService = (function() {
    // Initialize global native interaction methods
    window.NativeCall = nativeCall.bind(this);

    var topics = {};
    var hOP = topics.hasOwnProperty;

    // *** Public interface ***//
    const pubInterface = {
        SetNativeConfig: function (config) {
            executeNativeConfig( config );
        },
        Subscribe: function (topic, listener) {
            return subscribe(topic, listener);
        },
        Publish: function (topic, info) {
            return publish(topic, info);
        }
    }

    return pubInterface;

    // *** Private methods ***//
    function subscribe (topic, listener) {
        // Create the topic's object if not yet created
        if(!hOP.call(topics, topic)) topics[topic] = [];

        // Add the listener to queue
        var index = topics[topic].push(listener) -1;

        // Provide handle back for removal of topic
        return {
            remove: function() {
                delete topics[topic][index];
            }
        };
    }

    function publish (topic, info) {
        // If the topic doesn't exist, or there's no listeners in queue, just leave
        if(!hOP.call(topics, topic)) return;

        // Cycle through topics queue, fire!
        topics[topic].forEach(function(item) {
            item(info !== undefined ? info : {});
        });
    }

    function nativeCall ( call ) {
        Object.keys(call).forEach(callKey => {
            const callSplit = callKey.split('.');
            const method = callSplit[0];
            const topic = callSplit[1];
            const params = call[callKey];

            console.log(`Calling ${method} for topic ${topic} with params ${params}`);
            pubInterface[method](topic, params);
        });

        // TODO: Replace with something meaningful.
        return JSON.stringify({"success":true});
    }

    function executeNativeConfig(config) {
        executeNative({"Lok8.Init": [ config ] });
    }

    function executeNative(config) {
        console.log("Attempting to execute native config pass for config:", config);
        if (window.Lok8) {
            window.Lok8.NativeCall( JSON.stringify(config) );
        } else {
            console.warn("NativeService::executeNativeConfig : window.Lok8 does not exist, native communication was not initialized.");
        }
    }
})();

export default NativeService;



// WEBPACK FOOTER //
// ./src/services/Native.js